import { NextPage } from 'next';
import { HomePageContentLayout } from '../ui/common/components/ContentLayouts';
import Homepage from '@/creditflowresearch/ui/components/staticPages/Homepage';
import withApplicationPropsV2 from '@/creditflowresearch/application/withApplicationPropsV2';
import { pageRedirectTo } from '@framework/router/Next/helpers';
import UserPlan from '@creditflowresearch/user-plan/UserPlan';
import buildAccessibleMarketOverviewUrl
  from '@/creditflowresearch/application/Preferences/buildAccessibleMarketOverviewUrl';

export const getServerSideProps = withApplicationPropsV2((context) => {
  const { plan, preferences, products, regions } = context.userPlanState;

  if (UserPlan.isSatisfiedStarterPlan(plan) && preferences) {
    const homePageUrl = buildAccessibleMarketOverviewUrl({ preferences, products, regions });

    if (homePageUrl) {
      return pageRedirectTo(homePageUrl);
    }
  }

  return {
    props: {},
  };
}, { needsLegacyDictionaries: false });

type TProps = Record<string, never>;

const Home: NextPage<TProps> = () => (
  <HomePageContentLayout>
    <Homepage />
  </HomePageContentLayout>
);

export default Home;
